import React from "react"
import Icon from "../../assets/chatbot/harvey.png"

class Chatbot extends React.Component {
  render() {
    // Refer script in gatsby-browser.js

    // https://cloud.google.com/dialogflow/es/docs/integrations/dialogflow-messenger
    // - reference documentation

    return (
      <>
        <style scope="df-messenger">
        {`
          df-messenger {
            --df-messenger-bot-message: #fff;
            --df-messenger-button-titlebar-color: #004A60;
            --df-messenger-button-titlebar-font-color: #fff;
            --df-messenger-chat-background-color: #fafafa;
            --df-messenger-font-color: #004A60;
            --df-messenger-input-box-color: #fff;
            --df-messenger-input-font-color: #004A60;
            --df-messenger-input-placeholder-font-color: #efefef;
            --df-messenger-minimized-chat-close-icon-color: rgba(0,0,0,.87);
            --df-messenger-send-icon: #004A60;
            --df-messenger-user-message: #ddd;
            --df-messenger-chip-color: #E1EAEC;
            --df-messenger-chip-border-color: #e0e0e0;
          }
        `}
        </style>
        <df-messenger
          intent="WELCOME"
          wait-open={true}
          chat-title="Harvey"
          agent-id={process.env.GATSBY_DIALOGFLOW_AGENT_ID}
          language-code="en"
          chat-icon={Icon}
        ></df-messenger>
      </>
    )
  }
}

export default Chatbot
